import { Search, Edit, Check, Settings, FileText } from "lucide-react";
import { Link } from "react-router";
function AccountingAllocation() {
  const allocations = [
    { id: 1, clientId: "CLI-001", invoiceNumber: "INV-2026-245", client: "Acme Corporation", amount: "$12,000.00", glAccount: "4000-100", costCenter: "CC-001", department: "Marketing", status: "Pending" },
    { id: 2, clientId: "CLI-002", invoiceNumber: "INV-2026-244", client: "Stellar Industries", amount: "$8,750.00", glAccount: "4000-200", costCenter: "CC-002", department: "Support", status: "Allocated" },
    { id: 3, clientId: "CLI-003", invoiceNumber: "INV-2026-243", client: "Global Tech Inc", amount: "$15,225.00", glAccount: "4000-100", costCenter: "CC-003", department: "Technology", status: "Allocated" },
    { id: 4, clientId: "CLI-004", invoiceNumber: "INV-2026-242", client: "Prime Consulting", amount: "$9,500.00", glAccount: "4000-300", costCenter: "CC-004", department: "Consulting", status: "Allocated" },
    { id: 5, clientId: "CLI-005", invoiceNumber: "INV-2026-241", client: "NextGen Solutions", amount: "$11,200.00", glAccount: "4000-100", costCenter: "CC-005", department: "Digital", status: "Pending" },
    { id: 6, clientId: "CLI-006", invoiceNumber: "INV-2026-240", client: "Innovate Labs", amount: "$7,750.00", glAccount: "4000-400", costCenter: "CC-006", department: "Innovation", status: "Allocated" }
  ];
  return <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Accounting Allocation</h1>
        <p className="text-gray-600 dark:text-gray-400">Allocate invoices to GL accounts and cost centers</p>
      </div>

      {
    /* Allocation Rules Link */
  }
      <div className="mb-6">
        <div className="flex gap-3">
          <Link
    to="/accounting-allocation/rules"
    className="app-btn-gloss"
  >
            <Settings className="w-5 h-5" />
            Manage Allocation Rules
          </Link>
          <Link
    to="/accounting-allocation/detail"
    className="app-btn-gloss"
  >
            <FileText className="w-5 h-5" />
            View Allocation Detail
          </Link>
        </div>
      </div>

      {
    /* Search and Actions */
  }
      <div className="mb-6 flex items-center justify-between">
        <div className="flex gap-4 flex-1">
          <div className="relative flex-1 max-w-md">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
    type="text"
    placeholder="Search allocations..."
    className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
  />
          </div>
          <select className="px-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
            <option>All Status</option>
            <option>Pending</option>
            <option>Allocated</option>
          </select>
          <select className="px-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
            <option>All Departments</option>
            <option>Marketing</option>
            <option>Support</option>
            <option>Technology</option>
            <option>Consulting</option>
          </select>
        </div>
        <button className="app-btn-gloss ml-4">
          <Check className="w-5 h-5" />
          Bulk Allocate
        </button>
      </div>

      {
    /* Allocations Table */
  }
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Client ID</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Client</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Amount</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-800">
              {allocations.map((allocation) => <tr key={allocation.id} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                  <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">{allocation.clientId}</td>
                  <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">{allocation.client}</td>
                  <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">{allocation.amount}</td>
                  <td className="px-6 py-4 text-sm">
                    <span className={`px-2 py-1 rounded text-xs ${allocation.status === "Allocated" ? "bg-blue-600 text-white" : "bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100"}`}>
                      {allocation.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <div className="flex items-center gap-2">
                      <button className="app-btn-plain p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors">
                        <Edit className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                      </button>
                      <button className="app-btn-plain p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors">
                        <Check className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {
    /* Summary Section */
  }
      <div className="mt-6 grid grid-cols-3 gap-6">
        <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 p-6 rounded shadow-sm">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Total Pending</p>
          <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">$23,200.00</p>
        </div>
        <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 p-6 rounded shadow-sm">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Total Allocated</p>
          <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">$41,725.00</p>
        </div>
        <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 p-6 rounded shadow-sm">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Total Revenue</p>
          <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">$64,925.00</p>
        </div>
      </div>
    </div>;
}
export {
  AccountingAllocation
};
